module.exports = __webpack_public_path__ + "static/media/R-300HD_CrossSection.0be28e5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/fr/R-300HD_CrossSection.png
// module id = 494
// module chunks = 0